module.exports = __webpack_public_path__ + "Flama-Thin.ttf?9c51f3f8594781580b785f6778c6451f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Thin.ttf
// module id = 898
// module chunks = 0